BoardListSidebarItemView = require 'views/boards-sidebar/board-list-sidebar-item-view'
SidebarState = require 'view-models/sidebar-state'
View = require 'view'
_ = require 'underscore'
t = require('views/internal/teacup-with-helpers')('boards_sidebar_section')
Util = require 'lib/util'
l = require 'lib/localize'
track = require 'debug/track'
{ trackUnsplashViewBySavedUrl } = require 'network/unsplash'

template = t.renderable ({ title, iconClass, url, isOrg, orgLogoUrl, displayName, sectionId }) ->
  t.div '.sidebar-section-header.quiet.js-sidebar-section-header', ->

    if !isOrg?
      if title
        if iconClass
          t.icon iconClass, { class: 'sidebar-section-header-icon' }
        t.span '.sidebar-section-header-title', ->
          t.text title

    else
      t.a '.dark-hover', { href: url }, ->

        if !orgLogoUrl
          t.icon 'organization', { class: 'sidebar-section-header-icon' }
        else
          t.img
            class: 'sidebar-section-header-icon'
            src: orgLogoUrl
            alt: displayName

        t.span '.sidebar-section-header-title.mod-clickable', ->
          t.text displayName
        t.icon 'business-class', { class: 'sidebar-section-header-bc-icon hide js-has-business-class' }

    if sectionId
      t.icon 'remove', { class: 'sidebar-section-header-toggle-icon dark-hover js-collapse-section hide' }
      t.icon 'add', { class: 'sidebar-section-header-toggle-icon dark-hover js-expand-section hide' }

  t.div '.js-section-content', ->
    t.div '.js-starred-empty-state.sidebar-starred-boards-empty-state.hide', ->
      if sectionId == 'starred-boards'
        t.format 'star-your-most-important-boards'
    t.ul '.sidebar-boards-list.js-board-list'

    t.div ->
      t.a '.dark-hover.quiet-button.js-show-all-section-boards', { href: '#' }

module.exports = class BoardsSidebarSectionView extends View

  events:
    'click .js-collapse-section': 'collapseSection'
    'click .js-expand-section': 'expandSection'
    'click .js-show-all-section-boards': 'showAllSectionBoards'

  initialize: ->
    @debouncedRenderBoards = @debounce(@renderBoards, 10)
    @debouncedPostRenderBoardsEvent = @debounce(@postRenderBoardsEvent, 150)

    @sectionId = @sectionId()

    @initedSortable = false

    @listenTo SidebarState, 'change:collapsedDrawerSections', ->
      @renderCollapsed()

    @listenTo @model.boardList, 'add remove reset change:closed', @debouncedRenderBoards

    @truncated = @doesTruncate()

    photoPaths = []
    boards = @getBoards()
    for board in boards
      if board?.isOpen() && board.getPref('backgroundImage')
        photoPaths.push(board.getPref('backgroundImage'))
    if photoPaths.length
      trackUnsplashViewBySavedUrl photoPaths

  render: ->
    data = @getHeaderInfo()
    data.sectionId = @sectionId

    @$el.html template(data)

    @renderBoards()
    @renderCollapsed()

    @

  getBoards: -> []

  getHeaderInfo: -> "Boards"

  sectionId: -> null

  sectionName: -> null

  showOrgName: -> false

  isRecent: -> false

  doesTruncate: -> false

  postRenderBoardsEvent: -> return

  showAllSectionBoards: ->
    @truncated = false
    @renderBoards()
    return

  collapseSection: (e) ->
    SidebarState.collapseSection @sectionId
    track("Boards Drawer", "Collapse Section", @sectionName())

  expandSection: (e) ->
    SidebarState.expandSection @sectionId
    track("Boards Drawer", "Expand Section", @sectionName())

  renderCollapsed: ->
    isCollapsed = SidebarState.isCollapsed @sectionId

    @$('.js-collapse-section').toggleClass('hide', isCollapsed)
    @$('.js-expand-section').toggleClass('hide', !isCollapsed)

    @$('.js-section-content').toggleClass('hide', isCollapsed)
    @$('.js-sidebar-section-header').toggleClass('bold', !isCollapsed)

    return

  renderSubviews: (boards) ->
    $boards = @$('.js-board-list')
    boardViews =
      for board in boards
        @subview(BoardListSidebarItemView, board, { showOrgName: @showOrgName(), recent: @isRecent(), sectionName: @sectionName() }, "board-#{board.id}")
    @ensureSubviews(boardViews, $boards)
    return

  renderBoards: ->
    boards = _.filter(@getBoards(), (board) -> board?.isOpen())

    if boards.length > 0
      if @sectionId == 'starred-boards'
        @$('.js-board-list').removeClass('hide')
        @$('.js-show-all-section-boards').removeClass('hide')
        @$('.js-starred-empty-state').addClass('hide')

      displayedBoards =
        if !@doesTruncate()
          boards
        else
          _.chain boards
            .sortBy (board) -> -(new Date(board.get('dateLastActivity') ? Util.idToDate(board.id)))
            .filter (board, index) => !@truncated || index <= 10 || !board.isLessActive()
            .sortBy (board) -> board.get('name').toLowerCase()
            .value()

      count = (boards.length - displayedBoards.length)

      @$el.removeClass('hide')
      @renderSubviews(displayedBoards)

      @$('.js-show-all-section-boards').toggleClass('hide', count == 0).text(l(['templates', 'boards_sidebar_section', 'show-less-active-boards-count'], { countString: count.toString() }))
    else
      if @sectionId == 'starred-boards'
        @$('.js-board-list').addClass('hide')
        @$('.js-show-all-section-boards').addClass('hide')
        @$('.js-starred-empty-state').removeClass('hide')
        @$el.removeClass('hide')
      else
        @$el.addClass('hide')

    @debouncedPostRenderBoardsEvent()

    @



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-section-view.coffee